<template>
    <div :class="map !== undefined || map === false ? '' : 'view'">
        <div class="d-md-flex justify-content-md-between">
            <Breadcrumb :breadcrumb="breadcrumb"/>
            <div class="navigation duties" v-if="single_object.next || single_object.previous">
                <a class="navigation__item modal__buttons__item" :href="single_object.previous ? `${child_href}${single_object.previous}`: '#'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="11.702" height="21.184" viewBox="0 0 11.702 21.184">
                        <g id="left-arrow" transform="translate(0.313 0.312)">
                            <g id="Grupo_6167" data-name="Grupo 6167" transform="translate(0 0)">
                            <path id="Trazado_3202" data-name="Trazado 3202" d="M104.207,10.275l8.935,8.934a.791.791,0,0,1-1.119,1.119l-9.494-9.493a.791.791,0,0,1,0-1.119L112.023.223a.791.791,0,0,1,1.119,1.119Z" transform="translate(-102.298 -0.001)" stroke="#fff" stroke-width="0.5"/>
                            </g>
                        </g>
                    </svg>
                    Previous
                </a>
                <a class="navigation__item modal__buttons__item ml-2" :href="single_object.next ? `${child_href}${single_object.next}`: '#'">
                    Next
                    <svg xmlns="http://www.w3.org/2000/svg" width="11.702" height="21.184" viewBox="0 0 11.702 21.184">
                        <g id="left-arrow" transform="translate(0.313 0.312)">
                            <g id="Grupo_6167" data-name="Grupo 6167" transform="translate(0 0)">
                            <path id="Trazado_3202" data-name="Trazado 3202" d="M104.207,10.275l8.935,8.934a.791.791,0,0,1-1.119,1.119l-9.494-9.493a.791.791,0,0,1,0-1.119L112.023.223a.791.791,0,0,1,1.119,1.119Z" transform="translate(-102.298 -0.001)" stroke="#fff" stroke-width="0.5"/>
                            </g>
                        </g>
                    </svg>
                </a>
            </div>
        </div>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>

        <div class="col-md-12 p-0">
            <span class="button__modal text-right">
                <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                    <i class="prefix ml-1">
                        <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                    </i>
                </a>
            </span>
        </div>

        <div class="detail__content">
            <div class="row mb-0">
                <div class="col-12 col-md-8 py-0">
                    <form class="detail__content__formdynamic" @submit.prevent="form_submit_update_ext()">
                        <FormDynamic
                            :form_format="form_format"
                            :form_data="single_object"
                            :array_options="array_options"
                            :for_update="true"
                            class="pt-0"
                        />    
                        <div class="table-responsive defaultproject__table" style="width:100%;" v-if="tasks.length">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th v-for="(item, i) in task_table_headers" :key="i" scope="col" v-html="item.name"/>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in tasks" :key="i">
                                        <td>
                                            <span class="custom-control custom-radio">
                                                <input :id="`update_radio${i}`" type="radio" class="custom-control-input" name="task" :value="`${item.id}${i}`" v-model="task"/>
                                                <label :for="`update_radio${i}`" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td v-html="item.name"/>
                                        <td v-html="item.description"/>
                                        <td>
                                            <span>
                                                <input :id="`selectAlt1${i}`" type="number" class="form-control" v-model="item.frequency" :placeholder="'Policing frequency'"/>
                                            </span>
                                        </td>
                                        <td>
                                            <span>
                                                <input :id="`selectAlt2${i}`" type="number" class="form-control" v-model="item.order" :placeholder="'Order'"/>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="modal__buttons text-center text-md-right ">
                            <a :href="back_href" class="modal__buttons__item cancel" v-html="'Back'">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10.121" height="6.121" viewBox="0 0 10.121 6.121">
                                    <g id="down" transform="translate(1.061 1.061)">
                                        <line id="Línea_794" data-name="Línea 794" class="cls-1" x1="4" y1="4"/>
                                        <line id="Línea_795" data-name="Línea 795" class="cls-1" y1="4" x2="4" transform="translate(4)"/>
                                    </g>
                                </svg>
                            </a>
                            <button class="modal__buttons__item" v-html="`Save  <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`"/>
                        </div>
                    </form>
                </div>
                <div class="col-12 col-md-4 py-0">
                    <div class="row mb-0 no-gutters">
                        <div class="row mb-0 no-gutters detail__content__notes">
                            <div v-for="(note, i) in notes" :key="i" class="col-12 p-0 card cardModule hoverable">
                                <div class="card-content">
                                    <div class="card-title">
                                        <div class="row mb-0 no-gutters">
                                            <div class="col-10">
                                                <a href="#" @click="modal_update(i)" class="textTitleCard" v-html="`${note.title} / ${note.creation_date}`"/>
                                            </div>
                                            <div class="col-2 text-right">
                                                <a href="#" @click="modal_deletion(i)">
                                                    <i class="material-icons prefix ">
                                                        <img class="iconCard" src="/assets/img/trash.png" alt="date">
                                                    </i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <p class="mt-3 card-content__text" v-html="note.content"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div v-if="unalterable === undefined || unalterable === true" class="text-center text-md-right modal__buttons">
            <a :href="back_href" class="modal__buttons__item cancel" v-html="'Back'">
                <svg xmlns="http://www.w3.org/2000/svg" width="10.121" height="6.121" viewBox="0 0 10.121 6.121">
                    <g id="down" transform="translate(1.061 1.061)">
                        <line id="Línea_794" data-name="Línea 794" class="cls-1" x1="4" y1="4"/>
                        <line id="Línea_795" data-name="Línea 795" class="cls-1" y1="4" x2="4" transform="translate(4)"/>
                    </g>
                </svg>
            </a>
            <a class="mx-md-0 modal__buttons__item" @click="live_edition()" v-html="'Save changes'"/>
        </div> -->

        <FormModal
            :title="'New Note'"
            :breadcrumb="breadcrumb"
            :parent_id="parent_id"
            :rest_api="rest_api_note"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal
            :title="'Note Update'"
            :breadcrumb="breadcrumb"
            :parent_id="parent_id"
            :rest_api="rest_api_note"
            :array_options="array_options"
            :global_index="global_index"
            :single_object="single_note"
            @spliceObject="splice_object($event)"
        />

        <DeletionModal 
            :single_object="single_note" 
            :global_index="global_index" 
            @objectDeletion="deletion_filter($event)"
        />

        <WaitingModal/>
    </div>
</template>

<script>

import Breadcrumb       from  '@/components/BreadcrumbComponent/Breadcrumb.vue'
import WaitingModal     from  '@/components/WaitingModal.vue'
import FormDynamic      from  '@/components/FormDynamic.vue'
import DeletionModal    from  '@/components/DeletionModal'
import FormModal        from  '@/components/DetailComponent/FormModal'
import UpdateModal      from  '@/components/DetailComponent/UpdateModal'
import { Notyf }        from  'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
import 'vuetify/dist/vuetify.min.css'
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name:   'LocalDetailComponent',

    props: [
        'breadcrumb',
        'title_page',
        'parent_id',
        'rest_api',
        'child_href',
        'rest_api_note',
        'single_object',
        'array_options',
        'form_format',
        'notes',
        'task_table_headers',
        'tasks',
        'back_href',
        'map',
        'unalterable'
    ],

    components:{
        Breadcrumb,
        WaitingModal,
        FormDynamic,
        DeletionModal,
        FormModal,
        UpdateModal,
    },
    
    data() {
        return {
            notyf,
            add_btn:        'Add note',
            global_index:   '',
            single_note:    {},
            task:           '',
        }
    },

    watch: {
        "single_object.tasks"(val)
        {
            if(val) 
            {
                this.task = val.length ? (val[0].task_id ? val[0].task_id : this.task) : this.task 
                const task = this.tasks.find((v,j) => {
                    if(`${v.id}${j}` === `${this.task}${j}`) {
                        this.task = `${this.task}${j}`
                        return true
                    } else {
                        false
                    }
                })
                if(task) {
                    task.frequency = val[0].frequency
                    task.order = val[0].order
                }
            }
        }
    },

    methods:{

        form_modal()
        {
            window.$('#static').modal('show')
        },

        modal_update(index)
        {
            this.global_index = index
            this.single_note  = this.notes[index]
            window.$('#static-update').modal('show')
        },

        unshift_object(new_object)
        {
            this.notes.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.notes.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        modal_deletion(index)
        {
            this.global_index = index
            this.single_note  = this.notes[index]
            window.$('#static-deletion').modal('show')
        },

        deletion_filter(object)
        {
            let object_destroyed = {
                id:        object.id,
                index:     object.index,
                parent_id: this.parent_id,
            }
            this.json_destroyed(this.rest_api_note, object_destroyed)
        },

        trashing(index)
        {
            this.global_index = ''
            this.single_note  = {}
            this.notes.splice(index, 1)
        },

        async form_submit_update_ext()
        {

            if(this.single_object.unit < 1 || this.single_object.unit > 6)
            {
                this.notyf.error("Unit can't be lower than 1 nor higher than 6 either")
                return false
            }

            if(this.tasks.length)
            {
                const i = this.tasks.findIndex((v,j) => `${v.id}${j}` === this.task)
                let item = this.tasks[i]
                if(this.task)
                {
                    if(item.frequency === '')
                    {
                        this.notyf.error('Policing frequency cannot be empty')
                        setTimeout(() => {
                            window.$(`#selectAlt1${i}`).focus()
                        }, 500)
                        return false
                    }

                    if(item.order === '')
                    {
                        this.notyf.error('Order cannot be empty')
                        setTimeout(() => {
                            window.$(`#selectAlt2${i}`).focus()
                        }, 500)
                        return false
                    }
                    this.single_object.tasks = []
                    this.single_object.tasks.push(item)
                }
            }

            await this.form_submit_update(this.single_object)
        },

        async form_submit_update(single_object)
        {
            this.loader(true)
            const response = await this.patch(this.rest_api, single_object)
            if(response.status)
            {
                notyf.success(`Updated success!`)
                this.loader()
            } 
            else
            {
                this.error_handling(response)
                this.loader()
            }
        },

        // async live_edition()
        // {
        //     let response = await this.queryGetByMethod(this.rest_api, this.single_object)
        //     if(response.status)
        //     {
        //         this.single_object = response.data.data
        //         notyf.success('Success')
        //     }
        // },

    },
    
}
</script>